/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
// Components
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'

// Project Components
import Breadcrumb from '../../../components/breadcrumb/index'
import CategoryHeader from '../partials/category-header/category-header'
import {pxToRem} from '../../../utills/pxToRem'
import {fonts} from '../../../theme/foundations/fonts'

const PageHeader = ({category, searchQuery, articlesCount, selectedRefinements, ...otherProps}) => {
    // Create a handler to scroll to the "Related Articles" section
    const handleScrollToRelatedArticles = (e) => {
        e.preventDefault()
        const el = document.getElementById('search-related-articles')
        if (el) {
            el.scrollIntoView({behavior: 'auto', block: 'center'})
        }
    }

    return (
        <Box {...otherProps} data-testid="sf-product-list-breadcrumb">
            {/* Breadcrumb */}
            {category && <Breadcrumb categories={category.parentCategoryTree} />}
            {category &&
                category?.c_renderingTemplate !== 'rendering/category/catlanding' &&
                category?.c_renderingTemplate !== 'rendering/category/dynamiccategorylanding' && (
                    <CategoryHeader category={category} selectedRefinements={selectedRefinements} />
                )}
            {searchQuery && (
                <>
                    <Text
                        sx={{
                            fontFamily: fonts.primary,
                            fontWeight: 600,
                            fontSize: [pxToRem(22), pxToRem(22), pxToRem(30), pxToRem(30)],
                            lineHeight: 'normal',
                            letterSpacing: [pxToRem(3), pxToRem(3), pxToRem(4), pxToRem(4)],
                            color: 'black',
                            textTransform: 'uppercase',
                            height: [pxToRem(47), pxToRem(36), pxToRem(36), pxToRem(36)],
                            marginBottom: [pxToRem(15), pxToRem(15), pxToRem(20), pxToRem(20)]
                        }}
                    >
                        Search Results for &quot;{searchQuery}&quot;
                    </Text>
                    {articlesCount > 0 && (
                        <Link
                            onClick={handleScrollToRelatedArticles}
                            fontFamily={fonts.primary}
                            fontSize={[pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)]}
                            fontStyle="normal"
                            fontWeight={400}
                            lineHeight="normal"
                            letterSpacing={pxToRem(1)}
                            textDecoration="underline"
                            color="black"
                            as="button"
                            _hover={{
                                color: 'cav_hover_brightred'
                            }}
                        >
                            View ({articlesCount}) Related Articles Found
                        </Link>
                    )}
                </>
            )}
        </Box>
    )
}

PageHeader.propTypes = {
    category: PropTypes.object,
    isLoading: PropTypes.bool,
    searchQuery: PropTypes.string,
    selectedRefinements: PropTypes.object,
    articlesCount: PropTypes.number
}

export default PageHeader
